import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';
import { getDeviceGroupId } from 'utils/common/registerDevGroupID';

/**
 * Get room information for current device
 * @returns {Promise} Room data response
 */
function getCurrentRoom() {
  const deviceData = Storages.MainStorage.getItem(StorageKeys.Keys.DEVICEREGDATA);
  const deviceId = deviceData?.device_id;

  return httpService.get(`${ApiUrl.REGISTER_ROOM}?device_id=${deviceId}`).catch(() => {
    // If GET fails, try to create room
    const groupId = getDeviceGroupId();
    if (!deviceId || !groupId) {
      return { data: null };
    }

    const roomData = Storages.MainStorage.getItem(StorageKeys.Keys.ROOMDATA);

    return httpService
      .post(ApiUrl.REGISTER_ROOM, {
        device_id: deviceId,
        group_id: groupId,
        bed_no: roomData?.bed_no,
        building: roomData?.building,
        floor: roomData?.floor,
        poc: roomData?.poc,
        room_no: roomData?.room_no,
      })
      .then((response) => response)
      .catch(() => {
        return { data: null };
      });
  });
}

const obj = { getCurrentRoom };

export default obj;
